export const School = {
    path: '/schools',
    name: 'schools',
    component: () => import('@/views/Training/School/SchoolPage.vue'),
    children: [
        {
            path: '/schools/add',
            name: 'schools.add',
            component: () => import('@/views/Training/School/Form/SchoolForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/schools/edit/:id',
            name: 'schools.edit',
            component: () => import('@/views/Training/School/Form/SchoolForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/schools/delete/:id',
            name: 'schools.delete',
            component: () => import('@/views/Training/School/Form/SchoolForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/schools/view/:id',
            name: 'schools.view',
            component: () => import('@/views/Training/School/Form/SchoolForm.vue'),
            props: {viewAction: true}
        },
    ],
}
